export default {
  desktopWidth: 768,
  wideDesktopWidth: 1200,
  sidebar: {
    defaultWidth: 280,
    minWidth: 200,
    minSectionHeight: 200,
  },
  main: {
    minWidth: 200,
  },
  inspector: {
    drawer: {
      defaultHeight: 300,
      defaultWidth: 500,
      minWidth: 350,
      minHeight: 200,
    },
    preview: {
      minHeight: 200,
      minWidth: 200,
    },
  },
};
